import React from "react";

const PayrollCalculations = () => {
  return <div>PayrollCalculations</div>;
};

export default PayrollCalculations;
